import { Injectable } from '@angular/core';
import {HttpRequestService} from '../../../shared/services/http-request.service';
import {environment} from '../../../../environments/environment';

@Injectable()
export class EditGuestsService {
  private getEventGuestsURL = environment.apiUrl + '/GuestCms/GetGuestsForEvent';
  private updateEventGuestsURL = environment.apiUrl + '/GuestCms/UpdateEventGuests';
  constructor(private _http: HttpRequestService) {
  }
  getEventGuests(data) {
    return this._http.get(this.getEventGuestsURL + '?id=' + data);
  }
  updateEventGuests(data) {
    return this._http.post(this.updateEventGuestsURL, data);

  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-database/edit-guests/edit-guests.service.ts